// game/client/src/buildings/wonder-hud.ts
//
// Wonder Timer countdown HUD — floating top-bar widget that mirrors
// `room.state.wonderDeadlineMs` / `wonderTimerExtended`. Hidden when
// `deadline === 0` (no active timer). Server is authoritative; the client
// just formats `(deadline - now)` into `M:SS` per frame.
//
// `(extended)` prefix surfaces the one-shot extension (per
// `docs/design/16-buildings.md` Wonder timer rules) so players know the
// timer was reset because a contesting Wonder is under construction.
export interface WonderHud {
  update(args: { deadline: number; extended: boolean; now: number }): void;
  hide(): void;
}

export function createWonderHud(): WonderHud {
  const root = document.createElement("div");
  root.className = "wonder-hud";
  root.style.display = "none";
  document.body.appendChild(root);

  function update({ deadline, extended, now }: { deadline: number; extended: boolean; now: number }): void {
    if (deadline === 0) {
      root.style.display = "none";
      return;
    }
    root.style.display = "block";
    const ms = Math.max(0, deadline - now);
    const m = Math.floor(ms / 60000);
    const s = Math.floor((ms % 60000) / 1000).toString().padStart(2, "0");
    root.textContent = `Wonder Timer ${extended ? "(extended) " : ""}${m}:${s}`;
  }

  function hide(): void {
    root.style.display = "none";
  }

  return { update, hide };
}
